'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AcessibleDatePicker = require('./components/AcessibleDatePicker.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AcessibleDatePicker).default;
  }
});
Object.defineProperty(exports, 'AcessibleDatePicker', {
  enumerable: true,
  get: function get() {
    return _AcessibleDatePicker.AcessibleDatePicker;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-date-picker/lib/index.js
// module id = 272
// module chunks = 1